import script from "./Tidal.vue?vue&type=script&setup=true&lang=js"
export * from "./Tidal.vue?vue&type=script&setup=true&lang=js"

import "./Tidal.vue?vue&type=style&index=0&id=7bec06eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bec06eb"]])

export default __exports__